// extracted by mini-css-extract-plugin
export default {"cardContainer":"concern_cardContainer__jIMIm","showCard":"concern_showCard__sMIr5","editStyle":"concern_editStyle__D7JVy","font20":"concern_font20__9IewF"};